// import { authHeader } from '../../../../../auth';

export default {
    name: "AddWhyJoinUs",
    data() {
        return {
            title: '',
            description: '',
            icon: '',
            previewIcon: null
        }
    },
    async created() {
        document.title = "Dispo - Add Career Department";
    },
    methods: {
        onIconChange: function (event) {
            this.icon = event.target.files[0];
            let input = this.$refs.icon;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader;
                reader.onload = e => {
                    this.previewIcon = e.target.result;
                }
                reader.readAsDataURL(file[0]);
            }
        },
        validate: function() {
            if(!this.title) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter title!"
                });
                return false;
            }
            if(!this.description) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please enter description!"
                });
                return false;
            }
            if(!this.icon) {
                this.$swal.fire({
                    icon: "error",
                    text: "Please upload icon!"
                });
                return false;
            }
            return true;
        },
        save: async function() {
            if(this.validate() == true) {
                let token = localStorage.getItem('token');
                const formData = new FormData();
                formData.append("icon", this.icon);
                formData.append("title", this.title);
                formData.append("description", this.description);
                let config = {
                    method: "POST",
                    url: this.$serverURL + this.$api.cms.whyJoinUsURL,
                    data: formData,
                    headers: {
                        "Authorization": "Bearer " + token,
                        "Content-Type": "multipart/form-data"
                    }
                };
                await this.$axios(config).then((response) => {
                    if(response.status == 201) {
                        this.$swal.fire({
                            toast: true,
                            position: 'top-end',
                            text: response.data.message,
                            icon: "success",
                            showConfirmButton: false,
                            timer: 3000,
                            animation: false,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', this.$swal.stopTimer)
                                toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                            }
                        });
                    }
                    this.title = '';
                    this.description = '';
                    this.logo = '';
                    this.$refs.icon.value = null;
                    this.$router.push("/why-join-us");
                }).catch(error => {
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: "error",
                        text: error.response.data.message
                    });
                });
            }
        }
    }
}